import { Organization } from '@/types/organization';
import { createContext } from 'react';

export interface OrgContextType {
  selectedOrg: Organization | null;
  setSelectedOrg: (org: Organization | null) => void;
  isAdmin: boolean;
  isInitializing: boolean;
}

export const OrgContext = createContext<OrgContextType | undefined>(undefined);
